import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import ServiceTypeCard from "./ServiceTypeCard";
import * as moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import axios from "axios";
import API from "../helpers/api";
import { getEquipmentServiceTypeList } from "../Actions/CommonAPI";
import { getShipDeatil } from "../Actions/ShipEquipmentDetailsAPI";
import i18n from "./DropdownLanguage/i18n";

class EquipmentServiceTypes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceTypes: [],
    };
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    this.props.dispatch({
      type: "getEquipmentServiceTypeListSuccess",
      data: null,
    });
    dispatch({ type: "SubBannerTitle", data: "Service Update" })
    this.props.dispatch({ type: "EquipmentServiceTypeDetail", data: null });
    if (match.params.shipId) {
      dispatch(getShipDeatil(match.params.shipId));
    }

    if (match.params.equipId) {
      dispatch(getEquipmentServiceTypeList(match.params.equipId));
    }
  }
  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch } = nextProps;
    // if (nextProps.isMDSearch) {
    //   prevState.searchEquipment = nextProps.MDSearchData;
    // }

    // if (nextProps.MDDeleteSuccess) {
    //   // prevState.searchEquipment = nextProps.MDSearchData;
    //   // dispatch(getShipEquipmentSearchlist(prevState.searchEquipment));
    // }
  }
  hideSidePanel() {
    this.props.history.goBack();
    // this.props.dispatch({
    //   type: "getEquipmentServiceTypeListSuccess",
    //   data: null,
    // });
    // this.props.dispatch({ type: "EquipmentServiceTypeDetail", data: null });
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: "getEquipmentServiceTypeListSuccess",
      data: null,
    });
    this.props.dispatch({
      type: "EquipmentServiceTypeDetail",
      data: null,
    });
  }

  render() {
    const {
      shipDetail,
      equipmentServiceTypeList,
      editEquipmentDetailsPane,
      t
    } = this.props;
    const isArabic = i18n.language === 'arab';
    return (
      <div className="full-height">
        <div className="row mt-3">
          <button
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-2 ml-3"
            onClick={() => this.hideSidePanel()}
          >
            &larr; {t("CommonText.Back")}
          </button>
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header"
                style={{ backgroundColor: "white" }}>
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}>
                    {t("ShipEquipmentStatusScreen.ShipDetails")}
                  </h5>
                </div>
              </div>
              <div className="py-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className={"col-sm-12"}>
                      <div className="row mx-2">
                        <div
                          className={
                            editEquipmentDetailsPane
                              ? "col-sm-6 mb-2 "
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span>
                            <strong>{t("content.Shipname")}: </strong>
                            <span className="lato">
                              {shipDetail.shipName ? shipDetail.shipName : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            editEquipmentDetailsPane
                              ? "col-sm-6 mb-2 "
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span className={`${isArabic ? 'arabic' : ''}`}>
                            <strong>{t("content.IMOno")} </strong>
                            <strong>:</strong>
                            <span className="lato">
                              {shipDetail.imoNo ? shipDetail.imoNo : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            editEquipmentDetailsPane
                              ? "col-sm-6 mb-2 "
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span>
                            <strong>{t("TopPaneContent.TypeofShip")}: </strong>
                            <span className="lato">
                              {shipDetail.typeOfShip
                                ? shipDetail.typeOfShip
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            editEquipmentDetailsPane
                              ? "col-sm-6 mb-2 "
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                            <strong>{t("ShipEquipmentStatusScreen.DateofBuild")} </strong>
                            <strong>:</strong>
                            
                          </span>
                          <span className="lato">
                              {shipDetail.dateOfBuild
                                ? moment(shipDetail.dateOfBuild).format(
                                  "DD MMM YYYY"
                                )
                                : ""}
                            </span>
                        </div>
                        <div
                          className={
                            editEquipmentDetailsPane
                              ? "col-sm-6 mb-2 "
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span>
                            <strong>{t("TopPaneContent.Flag")}: </strong>
                            <span className="lato">
                              {shipDetail.flag ? shipDetail.flag : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            editEquipmentDetailsPane
                              ? "col-sm-6 mb-2 "
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span>
                            <strong>{t("TopPaneContent.Class")}: </strong>
                            <span className="lato">
                              {shipDetail ? shipDetail.class?.length === 0 ? " " : shipDetail.class?.length > 1 ? shipDetail.class?.map((item) => { return item }).join(',' + " ") : shipDetail.class?.map((i) => i) : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            editEquipmentDetailsPane
                              ? "col-sm-6 mb-2 "
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span>
                            <strong>{t("ShipManagementContent.GRT")}: </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="lato">
                              {shipDetail.grt ? shipDetail.grt : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            editEquipmentDetailsPane
                              ? "col-sm-6 mb-2 "
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                            <strong>{t("ShipManagementContent.DeadWeight")} </strong>
                            <strong>:</strong>
                            {" "}
                            <span className="lato">
                              {shipDetail.deadWeight
                                ? shipDetail.deadWeight
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            editEquipmentDetailsPane
                              ? "col-sm-6 mb-2 "
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                            <strong>{t("EquipmentSeviceDetailsScreen.EnrollmentDate")} </strong>
                            <strong>:</strong>
                            
                          </span>
                          <span className="lato">
                              {shipDetail?.enrollmentDate
                                ? moment(shipDetail?.enrollmentDate).format(
                                  "DD MMM YYYY"
                                )
                                : ""}
                            </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {equipmentServiceTypeList ? (
          <ServiceTypeCard
            arraylist={equipmentServiceTypeList}
          // pageSize={shipSearchResult.pagination.pageSize}
          // totalRecords={shipSearchResult.pagination.totalcount ? shipSearchResult.pagination.totalcount : 0}
          // setUpdatedState={(value) => this.SearchEquipmentData(value)}
          // shipId={this.state.searchEquipment.shipId}
          />
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    shipDetail: state.ShipEquipmentReducer.ShipDetail || {},
    equipmentServiceTypeList:
      state.SidePanReducer.EquipmentServiceTypeList || [],
    editEquipmentDetailsPane:
      state.SidePanReducer.EditEquipmentDetails || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(EquipmentServiceTypes));
